import { PlaceOrderApiResOrderItem } from "types/order";

export const getOrderStatusColor = (
  status: string
): "success" | "warning" | "info" | "error" | "default" => {
  switch (status) {
		case "completed":
			return "success";
		case "pending":
		case "open":
		case "created":
		case "in_progress":
			return "warning";
		case "cancelled":
		case "failed":
		case "rejected":
			return "error";
		case "others":
			return "info";

		default:
			return "default";
	}
};

export const calculateOrderPlacedCount = (
  orderList: PlaceOrderApiResOrderItem[]
) => {
  if (orderList.length === 0) {
    return { success: 0, failed: 0 };
  }
  const result = orderList.reduce(
    (acc: any, curr: any) => {
      switch (curr.orderStatus) {
        case "open":
        case "completed":
        case "others":
          acc.success++;
          break;
        case "failed":
        case "rejected":
          acc.failed++;
          break;
        default:
          acc.failed++;
          break;
      }
      return acc;
    },
    { success: 0, failed: 0 }
  );
  return result;
};
